import { BaseAbstractService } from "@common/service/base-service/global";
import { ICTExamApi } from "@common/ict/api/exam";
import { ExamDetailsRET } from "@common/ict/model/interface/exam";
import { TO_C_HOME_URL } from "@common/ict/model/data/index";
import { toClientWithToken } from "@common/ict/service/common";
import { ICTRequestService } from "@common/ict/service/base-service/request";
//2b service整合进来
export class ExamService extends BaseAbstractService {
  static allTime; // 可考次数总数
  // 获取考试详情
  static getExamDetails(data: {
    evaluationPlanId: string;
    trainingPlanId: string;
  }) {
    return ICTExamApi.getExamDatile(this.request, data).then(
      (res): ExamDetailsRET => {
        const evaluationPlan4BaseDTO = res.data.evaluationPlan4BaseDTO;
        const implementPlanBaseDTO = res.data.implementPlanBaseDTO;
        const ruleEvaluationRela4BaseDTO = res.data.ruleEvaluationRela4BaseDTO;
        const proposalPlan4BaseDTO = res.data.proposalPlan4BaseDTO;
        ExamService.allTime = JSON.parse(
          ruleEvaluationRela4BaseDTO.find(element => element.ruleId == 6).res
        ).count;
        // 获取是否打乱顺序
        const optionRadom = ruleEvaluationRela4BaseDTO.find(
          element => element.ruleId == 5
        ).res;
        const questionRadom = ruleEvaluationRela4BaseDTO.find(
          element => element.ruleId == 4
        ).res;
        ExamService.allTime = JSON.parse(
          ruleEvaluationRela4BaseDTO.find(element => element.ruleId == 6).res
        ).count;
        const ret: ExamDetailsRET = {
          type: implementPlanBaseDTO.type,
          time: `${implementPlanBaseDTO.startTime} -- ${implementPlanBaseDTO.endTime}`,
          startExam:
            implementPlanBaseDTO.type == null ? 1 : implementPlanBaseDTO.type,
          examName: evaluationPlan4BaseDTO.name, // 考试名称
          examTotalPoints: "0", // 总分
          examState: false, // 考试状态
          residueTime: 0, // 剩余次数
          allTime: ExamService.allTime, // 全部次数
          examDuration: evaluationPlan4BaseDTO.duration || 0, // 考试时长
          passedScore: Math.ceil(
            (proposalPlan4BaseDTO[0].totalScore *
              evaluationPlan4BaseDTO.passedScore) /
              100
          ), // 通过分数
          passMark: proposalPlan4BaseDTO[0].totalScore, // 及格分数-总分
          testPaperInfo: {
            singleChoiceNum: 10, // 单选题数
            singleChoiceScore: 10, // 单选 分数
            multipleChoiceNum: 10, // 多选 题数
            multipleChoiceScore: 10, // 多选 分数
            trueOrFalseQuestionsNum: 10, // 判断 题数
            trueOrFalseQuestionsScore: 10 // 判断 分数
          },
          message: evaluationPlan4BaseDTO.notice,
          code: implementPlanBaseDTO.code || "1",
          implementPlanId: implementPlanBaseDTO.id || "1",
          BuildPaperData: {
            optionRadom: optionRadom,
            proposalPlanId: proposalPlan4BaseDTO[0].id,
            questionRadom: questionRadom
          },
          isShowQuestionInfo: proposalPlan4BaseDTO[0].type != 1,
          rules: ruleEvaluationRela4BaseDTO
        };
        return ret;
      }
    );
  }
  // 开始考试
  static startExam(data: { code: string; id: string }) {
    return ICTExamApi.startExam(this.request, data).then(res => res.data);
  }

  // 提交试题
  static submitQuestion(data: {
    studentTaskId: string;
    paperId: string;
    implementId: string;
    questionId: string;
    answer: string;
  }) {
    return ICTExamApi.submitQuestion(this.request, data).then(res => res.data);
  }

  // 行为提交
  static submitBehavior(data: {
    studentTaskId: string;
    paperId: string;
    implementId: string;
    behaviorType: string;
    behaviorDesc: string;
    result?: string;
  }) {
    return ICTExamApi.submitBehavior(this.request, data).then(res => res.data);
  }

  // 组建试卷，并保存
  static commandBuildPaper(data: {
    optionRadom: string;
    proposalPlanId: string;
    questionRadom: string;
  }) {
    return ICTExamApi.commandBuildPaper(this.request, data).then(res => res);
  }

  // 获取考题信息 题数 分数 相关
  static getExamInfo(data) {
    return ICTExamApi.getExamInfo(this.request, data).then(res => {
      const query = {
        singleChoiceNum: 10, // 单选题数
        singleChoiceScore: 10, // 单选 分数
        multipleChoiceNum: 10, // 多选 题数
        multipleChoiceScore: 10, // 多选 分数
        trueOrFalseQuestionsNum: 10, // 判断题数
        trueOrFalseQuestionsScore: 10 // 判断 分数
      };
      res.data.forEach(element => {
        switch (element.type) {
          case 0:
            query.singleChoiceNum = element.questionNum;
            query.singleChoiceScore = element.totalScore;
            break;
          case 1:
            query.multipleChoiceNum = element.questionNum;
            query.multipleChoiceScore = element.totalScore;
            break;
          case 2:
            query.trueOrFalseQuestionsNum = element.questionNum;
            query.trueOrFalseQuestionsScore = element.totalScore;
            break;
        }
      });
      return query;
    });
  }
  // 结束考试
  static endExam(data) {
    return ICTExamApi.endExamApi(this.request, data).then(res => res.data);
  }
  static getExamTask(data) {
    return ICTExamApi.getExamTask(this.request, data).then(res => res.data);
  }
  // 获取考试记录
  static getExamRecord(data: { implementId: string }) {
    return ICTExamApi.getExamRecord(this.request, data).then(res => {
      const list = res.data;
      let isPassed = false;
      let maxTotal = 0;
      // 遍历数组
      list.forEach(element => {
        const updateTime =
          element.createdDate !== null
            ? element.createdDate.split("")
            : ["-", "-"];
        updateTime.splice(10, 1, " ");
        updateTime.splice(19);
        element.showDate = updateTime.join("");
        // 考试状态
        if (element.isPassed) {
          isPassed = true;
        }
        // 获取最高
        if (element.score > maxTotal) {
          maxTotal = element.score;
        }
      });

      const query = {
        list: list,
        examState: isPassed,
        residueTime: ExamService.allTime - list.length, // 剩余次数
        examTotalPoints: maxTotal
      };
      res.data;
      return query;
    });
  }

  // 获取考试记录详情
  static getExamRecordDetail(query: { taskId: string }) {
    return ICTExamApi.getExamRecordDetail(this.request, query).then(res => {
      const questionList = res.data.userAnswerDTOS.map(item => {
        return {
          ...item,
          options: [...item.optionsClones]
        };
      });
      res.data.userAnswerDTOS = questionList;
      return res.data;
    });
  }
  static GetBizClassExams(data) {
    return ICTExamApi.GetBizClassExams(this.request, data);
  }
  static toExamDetail(router, examInfo) {
    switch (examInfo?.id) {
      case examInfo.id:
        toClientWithToken(
          `${TO_C_HOME_URL}/pc/exam/start?examId=${examInfo.id}`
        );
        break;
    }
  }
  // 考试统计接口
  static examCollectCourse(query) {
    return ICTExamApi.examCollectCourse(this.request, query).then(res => {
      return res.data;
    });
  }
}
